









import {Component, Prop} from 'vue-property-decorator';
import {mixins}          from 'vue-class-component';
import MainMixin         from '@/mixins/Main';

@Component({
    name: `UsernameContainer`
})
export default class UsernameContainer extends mixins(MainMixin)
{
    @Prop({default: false, type: Boolean}) public readonly adminShow!: boolean;
    @Prop({default: true, type: Boolean}) public readonly connectivityShow!: boolean;
    @Prop({default: false, type: Boolean}) public readonly dnfShow!: boolean;
    @Prop({required: true, type: Number}) public readonly userId!: number;

    public get connectivity(): Connectivity
    {
        return this.user.online?.includes(this.categoriesActive) ? `online` : `offline`;
    }

    public get user(): DeepReadonlyObject<Omit<UserValue, 'id'>>
    {
        const {state} = this.$store;
        const {userLogged} = state;

        return state.users.value[this.userId] || (userLogged.id === this.userId && {username: userLogged.username});
    }
}
